import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { LoginSubjectObligedComponent } from './login-subject-obliged/login-subject-obliged.component';

const publicRoutes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'password-reset-confirmation', component: PasswordResetComponent },
      { path: 'confirm-email', component: ConfirmEmailComponent },
      { path: 'account/confirm-email', redirectTo: 'confirm-email' },
      { path: '', redirectTo: '/login', pathMatch: 'full' },
    ],
  },
  { path: 'select', component: LoginSubjectObligedComponent }
];

export const PUBLIC_ROUTES = RouterModule.forChild(publicRoutes);
